import { render } from "./NavItem.vue?vue&type=template&id=4b680710&scoped=true&ts=true"
import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"

import "./NavItem.vue?vue&type=style&index=0&id=4b680710&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b680710"]])

export default __exports__